module.exports = __webpack_public_path__ + "static/img/image1.1a8f00d9.png";